module.exports = "<div class=\"tab-heading-heading\">Source</div>\n<div class=\"tab-heading-content\">\n  <span ng-bind=\"worker.name\"></span>\n</div>\n";